export default "<p>generalinfo works!</p>\n"